module.exports = __webpack_public_path__ + "static/Koineks-24a0b1c97c8cc14fdc92d3d4d8812557.png";